// Everything about *you* lives here — edit this file, the components update.
export const PROFILE = {
  name: 'Daniel Rice',
  tags: ['COAST GUARD VETERAN', 'CLASSICALLY TRAINED CHEF', 'FULL-STACK DEV'],
  bio: `Experienced Coast Guard veteran, classically trained chef, and eager
full-stack web developer proficient in JavaScript and Ruby. Specialized in
Rails and React.js, my insatiable curiosity and strong work ethic drive me to
continuously expand my programming expertise. Known for asking insightful
questions that propel me toward continuous learning and growth in the dynamic
field of computer programming.`,
  email: 'danielrice5627@gmail.com',
  phone: '206-755-2605',
  links: {
    github: 'https://github.com/danielerice',
    linkedin: 'https://www.linkedin.com/in/daniel-rice-1406a52a3/',
    resume:
      'https://www.dropbox.com/scl/fi/4s08r3e22lqabb31gtz7b/Daniel-Rice-s-Resume.pdf?rlkey=wmne178mmn74jf3vrdbiughq0&dl=0',
    medium: 'https://medium.com/@danielrice5627',
  },
};
